import Home from '../pages/index'
// import Second from '../pages/second'
import type { RouteRow } from './renderRoutes'

export const routeMapping: RouteRow[] = [
  {
    isIndex: true, //是否是首页
    path: '/', // url 路由
    route: '../pages/index', // 文件路径
    lazy: false,
    component: <Home />, // 非lazyload组件
  },
  // {
  //   isIndex: false,
  //   path: '/second',
  //   route: '../pages/second',
  //   lazy: false,
  //   component: <Second />,
  // },
]
